(function(){
'use strict';
var $=function(s,r){return (r||document).querySelector(s)},$$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
var mm=function(q){return window.matchMedia&&window.matchMedia(q).matches};
var reduce=mm('(prefers-reduced-motion: reduce)');
var fine=mm('(hover:hover) and (pointer:fine)');
function safe(f){try{return f()}catch(e){return null}}

/* Chargement (accueil, une fois par session, court) */
var loader=$('#loader'),started=false;
function start(){if(started)return;started=true;document.body.classList.add('go');var h=$('.hero');if(h)h.classList.add('go')}
if(loader){
  var seen=safe(function(){return sessionStorage.getItem('cab-seen')});
  if(seen||reduce){loader.remove();start()}
  else{
    var p=0,pct=$('#pct'),bar=$('#bar');
    var iv=setInterval(function(){
      p=Math.min(100,p+8+Math.ceil(Math.random()*14));pct.textContent=p;bar.style.width=p+'%';
      if(p>=100){clearInterval(iv);setTimeout(function(){loader.classList.add('done');start();safe(function(){sessionStorage.setItem('cab-seen','1')});setTimeout(function(){loader.remove()},900)},180)}
    },40);
    setTimeout(function(){if(!started){loader.classList.add('done');start()}},2500);
  }
}else start();

/* Menu mobile */
var burger=$('#burger'),links=$('#links');
if(burger){
  burger.addEventListener('click',function(){
    var o=burger.getAttribute('aria-expanded')==='true';
    burger.setAttribute('aria-expanded',String(!o));links.classList.toggle('open',!o);
    document.body.style.overflow=o?'':'hidden';
  });
  $$('a',links).forEach(function(a){a.addEventListener('click',function(){burger.setAttribute('aria-expanded','false');links.classList.remove('open');document.body.style.overflow=''})});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&links.classList.contains('open')){burger.click()}});
}

/* Apparition au scroll */
if('IntersectionObserver' in window&&!reduce){
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.08,rootMargin:'0px 0px -3% 0px'});
  $$('.reveal').forEach(function(el){io.observe(el)});
}else $$('.reveal').forEach(function(el){el.classList.add('in')});

/* Compteurs */
function countUp(el){var t=+el.dataset.count,s=performance.now();(function f(n){var k=Math.min(1,(n-s)/1600),v=1-Math.pow(1-k,4);el.textContent=Math.round(t*v);if(k<1)requestAnimationFrame(f)})(s)}
if('IntersectionObserver' in window&&!reduce){
  var co=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){co.unobserve(e.target);countUp(e.target)}})},{threshold:.6});
  $$('[data-count]').forEach(function(el){co.observe(el)});
}else $$('[data-count]').forEach(function(el){el.textContent=el.dataset.count});

/* Effets au scroll (calculés seulement quand la zone est visible) */
var nav=$('#nav'),mp=$('#manifest'),words=[],fbs=$$('.float-bottle'),house=$('#maisons'),hrow=$('#hrow'),hprog=$('#hprog'),lastY=0;
var vis={hero:true,mp:false,house:false};
if(mp){mp.innerHTML=mp.textContent.trim().split(/\s+/).map(function(w){return '<span class="w">'+w+'</span>'}).join(' ');words=$$('.w',mp)}
if('IntersectionObserver' in window){
  var vo=new IntersectionObserver(function(es){es.forEach(function(e){vis[e.target.dataset.v]=e.isIntersecting;onScroll()})},{rootMargin:'200px 0px'});
  [['.hero','hero'],['#manifeste','mp'],['#maisons','house']].forEach(function(a){var el=$(a[0]);if(el){el.dataset.v=a[1];vo.observe(el)}});
}else{vis.mp=true;vis.house=true}
function onScroll(){
  var y=window.scrollY;
  if(nav){nav.classList.toggle('scrolled',y>40);nav.classList.toggle('hide',y>lastY&&y>500&&!(links&&links.classList.contains('open')));}
  lastY=y;
  if(reduce){words.forEach(function(w){w.classList.add('lit')});return}
  if(vis.hero)fbs.forEach(function(b){b.style.translate='0 '+(y*(+b.dataset.speed))+'px'});
  if(mp&&vis.mp){var r=mp.getBoundingClientRect(),pr=Math.min(1,Math.max(0,(innerHeight*.85-r.top)/(r.height+innerHeight*.35)));words.forEach(function(w,i){w.classList.toggle('lit',i/words.length<pr)})}
  if(house&&hrow&&vis.house){var hr=house.getBoundingClientRect(),mx=house.offsetHeight-innerHeight,k=Math.min(1,Math.max(0,-hr.top/mx));hrow.style.transform='translateX('+(-k*Math.max(0,hrow.scrollWidth-innerWidth))+'px)';if(hprog)hprog.style.width=(k*100)+'%'}
}
window.addEventListener('scroll',onScroll,{passive:true});
window.addEventListener('resize',onScroll);onScroll();

/* Curseur, effet magnétique, inclinaison des cartes (souris uniquement) */
if(fine&&!reduce){
  var cur=$('#cursor'),cx=0,cy=0,tx=0,ty=0;
  if(cur){
    window.addEventListener('pointermove',function(e){tx=e.clientX;ty=e.clientY;cur.classList.add('on')},{passive:true});
    (function loop(){cx+=(tx-cx)*.2;cy+=(ty-cy)*.2;cur.style.transform='translate('+cx+'px,'+cy+'px)';requestAnimationFrame(loop)})();
    document.addEventListener('pointerover',function(e){cur.classList.toggle('big',!!(e.target.closest&&e.target.closest('.card .img,.coll a,.btn,.hrow a,.advice-card')))});
  }
  var mags=$$('.magnet'),lastT=0;
  document.addEventListener('pointermove',function(e){
    var now=e.timeStamp;if(now-lastT<16)return;lastT=now;
    mags.forEach(function(b){var r=b.getBoundingClientRect();if(r.bottom<-100||r.top>innerHeight+100)return;var dx=e.clientX-(r.left+r.width/2),dy=e.clientY-(r.top+r.height/2);b.style.transform=Math.hypot(dx,dy)<90?'translate('+dx*.25+'px,'+dy*.25+'px)':''});
    var c=e.target.closest&&e.target.closest('.card .img');
    if(window._tilt&&window._tilt!==c){window._tilt.style.transform='';window._tilt=null}
    if(c){var r2=c.getBoundingClientRect(),px=(e.clientX-r2.left)/r2.width-.5,py=(e.clientY-r2.top)/r2.height-.5;c.style.transform='perspective(800px) rotateY('+px*9+'deg) rotateX('+(-py*9)+'deg)';window._tilt=c}
  },{passive:true});
  var pi=$('.pimg');
  if(pi){var pimg=$('img,.art',pi);pi.addEventListener('pointermove',function(e){var r=pi.getBoundingClientRect(),px=(e.clientX-r.left)/r.width-.5,py=(e.clientY-r.top)/r.height-.5;if(pimg)pimg.style.transform='translate('+px*18+'px,'+py*18+'px) rotate('+px*4+'deg)'});pi.addEventListener('pointerleave',function(){if(pimg)pimg.style.transform=''})}
}

/* Message de confirmation */
window.toast=function(t){var e=$('#toast');if(!e)return;e.textContent=t;e.classList.add('show');clearTimeout(window._tt);window._tt=setTimeout(function(){e.classList.remove('show')},2400)};

/* Filtre de la sélection (accueil) */
var grid=$('#grid'),hf=$('#filters');
if(hf&&grid){
  hf.addEventListener('click',function(e){
    var b=e.target.closest('.chip');if(!b)return;
    $$('.chip',hf).forEach(function(x){x.classList.toggle('on',x===b);x.setAttribute('aria-pressed',String(x===b))});
    $$('.card',grid).forEach(function(c){c.hidden=!(b.dataset.t==='Tout'||c.dataset.type===b.dataset.t)});
  });
}

/* Choix de millésime (fiche produit) : prix + message de contact mis à jour */
var vf=$('#variants');
if(vf){
  var pp=$('#pp'),ask=$('#ask'),askBody=$('#ask-body');
  vf.addEventListener('change',function(e){
    var r=e.target;if(!r||r.name!=='variant')return;
    $$('.chip',vf).forEach(function(l){l.classList.toggle('on',l.contains(r))});
    if(pp)pp.textContent=r.dataset.price;
    if(ask){var base=ask.getAttribute('href').split('?')[0];ask.setAttribute('href',base+'?subject='+encodeURIComponent(ask.dataset.subject+' ('+r.dataset.title+')'))}
    if(askBody&&askBody.dataset.tpl){askBody.value=askBody.dataset.tpl.replace('{v}',' – millésime / version : '+r.dataset.title)}
  });
}

/* Contact : pré-remplissage depuis les cartes « conseil » ou ?sujet= */
var cbody=$('#cf-body');
$$('[data-prefill]').forEach(function(a){a.addEventListener('click',function(){
  if(cbody){cbody.value=a.getAttribute('data-prefill');setTimeout(function(){cbody.focus({preventScroll:true})},700)}
})});
var sp=safe(function(){return new URLSearchParams(location.search).get('sujet')});
if(sp&&cbody&&!cbody.value){cbody.value=sp}

/* Bouton de contact flottant : visible après le hero, caché près des formulaires */
var fc=$('#fcta');
if(fc&&'IntersectionObserver' in window){
  var forms=$$('#contact,.askbox'),inForm=false,pastHero=false;
  var upd=function(){fc.classList.toggle('show',pastHero&&!inForm)};
  var fo=new IntersectionObserver(function(es){es.forEach(function(e){inForm=e.isIntersecting});upd()},{threshold:.15});
  forms.forEach(function(f){fo.observe(f)});
  window.addEventListener('scroll',function(){pastHero=window.scrollY>Math.min(500,innerHeight*.6);upd()},{passive:true});
  pastHero=window.scrollY>400;upd();
}

/* Vérification d'âge (accessible : focus, défilement bloqué) */
var ag=$('#agegate');
if(ag){
  var ok=safe(function(){return localStorage.getItem('cab-age')==='18'});
  if(!ok){
    ag.hidden=false;document.body.classList.add('age-lock');
    var yes=$('#ag-yes'),no=$('#ag-no');
    if(yes)yes.focus();
    yes.addEventListener('click',function(){safe(function(){localStorage.setItem('cab-age','18')});ag.hidden=true;document.body.classList.remove('age-lock')});
    no.addEventListener('click',function(){$('#ag-title').textContent='Désolé, l’accès est réservé aux majeurs.';$('#ag-text').textContent='Revenez nous voir quand vous aurez l’âge légal.';$('.ageb',ag).hidden=true});
    ag.addEventListener('keydown',function(e){if(e.key!=='Tab')return;var f=$$('button:not([hidden])',ag).filter(function(b){return !b.closest('[hidden]')});if(!f.length)return;var first=f[0],last=f[f.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}});
  }
}
})();
